import React, { useEffect, useState, forwardRef, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveCompanies, getWoLoading, GetAgentDetails, ImportCompany, GetUserCompanies } from '../redux/store'
import { Input, Label, Row, Col, Button, TabContent, TabPane, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap'
import ComponentSpinner from '../../components/spinner/Loading-spinner'
import LoadingOpaqueSpinner from '../../components/spinner/Loading-opaque-spinner'
import DefaultSettings from '../../settings/pageSettings'
import { DefaultConfig } from '../../settings/config'
import '@styles/react/libs/tables/react-dataTable-component.scss'
import ReactPaginate from 'react-paginate'
import DataTable from 'react-data-table-component'
import { ChevronDown, ChevronUp, X, RefreshCcw, Plus, Filter } from 'react-feather'
import CustomValueContainer from "../Components/Select"
import Select, { components } from 'react-select'
import { ActiveCompanies } from "./Data"
import { useNavigate } from 'react-router-dom'
import classnames from 'classnames'
import Sidebar from '../Components/SideBar'
import toast from 'react-hot-toast'
import ToastMessage from '../../components/toast-messages'
import { isUserLoggedIn } from "../../@core/auth/utils"

const CompaniesList = () => {
    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(DefaultSettings.perPage)
    const selectStyles = DefaultConfig().selectStyles
    const SourceSystems = DefaultConfig().SourceSystem
    const navigate = useNavigate()

    const stores = useSelector((state) => state.commonreducerSlice)
    // const isEmployee = isUserLoggedIn() && JSON.parse(isUserLoggedIn()).isEmployee

    const [name, setName] = useState("")
    const [agentId, setAgentId] = useState("")
    const [sfUniqueId, setSfUniqueId] = useState("")

    const [address1, setAddress1] = useState("")
    const [address2, setAddress2] = useState("")
    const [city, setCity] = useState("")
    const [state, setState] = useState("")
    const [country, setCountry] = useState("")

    const [woData, setWoData] = useState([])
    const [sortName, setSortName] = useState("Id")
    const [sortOrder, setSortOrder] = useState("asc")
    const [displaytableData, setDisplaytableData] = useState(false)
    const [importCompany, setImportCompany] = useState([])
    const [show, setShow] = useState(false)

    const [agentInput, setAgentInput] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [addCompanyOption, setAddCompanyOption] = useState(false)
    const [agentObj, setAgentObj] = useState(null)
    const [sidebarSpinnerStatus, setSidebarSpinnerStatus] = useState(false)
    const [companyData, setCompanyData] = useState([])
    //const [stopMultiLoops, setStopMultiLoops] = useState(false)

    const [nameEnterKey, setNameEnterKey] = useState([])
    const [agentIdKey, setAgentIdEnterKey] = useState([])
    const [sfEnterKey, setSfUnqueIdEnterKey] = useState([])
    const [status, setStatus] = useState(3)
    const [id, setId] = useState(null)
    const [idEnterKey, setIdEnterKey] = useState([])
    const regionalOffices = DefaultConfig().regionalOffices
    const [regionalOption, setRegionalOption] = useState(null)
    const [region, setRegion] = useState("")
    const DepartmentMapping = DefaultConfig().DepartmentMapping
    const showImportCompBtn = DefaultConfig().ShownImportCompanyBtn
    const [department, setDepartment] = useState()
    const [departmentOption, setDepartmentOption] = useState()
    const loggedinUserDetails = isUserLoggedIn() && JSON.parse(isUserLoggedIn())
    //const [sourceSystemOption, setSourceSystemOption] = useState(null)
    //   const [sourceSystem, setSourceSystem] = useState(null)
    const [displayFitler, setDisplayFilter] = useState(true)

    const options = [
        { value: 'All', label: 'All', id: 3 },
        { value: 'Active', label: 'Active', id: 1 },
        { value: 'InActive', label: 'InActive', id: 2 }

    ]
    const [statusOption, setStatusOption] = useState(options[0])

    // const mappedSourceSystems = () => SourceSystems("options").map((portal) => ({
    //     value: portal.id,
    //     label: portal.label
    //   }))

    function loadingData(responseData) {
        const woDataObj = []
        if (stores.spinner3 && responseData.length > 0) {

            for (let i = 0; i < responseData.length; i++) {
                const element = { ...responseData[i] }
                woDataObj[i] = element
            }
        }
        setWoData(woDataObj)
        setDisplaytableData(false)
        setTimeout(() => {
            sessionStorage.removeItem('pageTransition')
        }, 1000)
    }

    const handleFilterData = (name, agentId, sfUniqueId, id, region, sortName, sortOrder, status, department) => {

        dispatch(getWoLoading(false))
        setDisplaytableData(true)
        setCurrentPage(0)
        const obj = {}
        if (true) {
            obj.name = name

            if (agentId?.length) {
                obj.agentId = String(agentId)
            }
            if (sfUniqueId?.length) {
                obj.sfUniqueId = sfUniqueId
            }
            if (region) {
                obj.regionalOfficeId = region
            }
            if (department) {
                obj.gpClientDepartmentId = Number(department)
            }
        }
        //   obj.sourceSystemId = sourceSystem
        obj.pageIndex = 1
        obj.pageSize = rowsPerPage
        obj.sortName = sortName
        obj.Id = id
        obj.sortOrder = sortOrder
        if (status !== 3) {
            obj.status = status
        }
        let responseData
        async function fetchData(data) {
            if (true) {
                if (loggedinUserDetails?.userRoles[0]?.roleId === 1) {
                    responseData = await dispatch(getActiveCompanies(obj))
                } else {
                    obj.isEmployee = loggedinUserDetails.isEmployee
                    obj.userId = loggedinUserDetails.userRoles[0].userId
                    responseData = await dispatch(GetUserCompanies(obj))
                }

                if (responseData.payload) {

                    loadingData(responseData.payload.data)
                } else {
                    setDisplaytableData(false)
                }
            }
        }
        fetchData(obj)
    }

    const customStyles = {
        rows: {
            style: {
                backgroundColor: '#f9f9f9'
            }
        }
    }

    const handleNameKeyDown = (event) => {
        if (event.key === 'Enter') {
            setNameEnterKey('Enter')
            if (event.target.value?.length > 0) {
                handleFilterData(event.target.value, agentId, sfUniqueId, id, region, sortName, sortOrder, status, department)
            }
        }
    }

    const handleIdKeyDown = (event) => {
        if (event.key === 'Enter') {
            setIdEnterKey('Enter')
            if (event.target.value) {
                handleFilterData(name, agentId, sfUniqueId, event.target.value, region, sortName, sortOrder, status, department)
            }
        }
    }


    function handleIdBlur() {
        if (id && idEnterKey !== 'Enter') {
            setTimeout(() => {
                handleFilterData(name, agentId, sfUniqueId, id, region, sortName, sortOrder, status, department)
            }, 100)

        }
    }

    const handleNameBlur = () => {
        if (name.length > 0 && nameEnterKey !== 'Enter') {
            setTimeout(() => {
                handleFilterData(name, agentId, sfUniqueId, id, region, sortName, sortOrder, status, department)
            }, 100)
        }
    }

    const handleAgentIdKeyDown = (event) => {
        if (event.key === 'Enter') {
            setAgentIdEnterKey('Enter')
            if (event.target.value?.length > 0) {
                handleFilterData(name, event.target.value, sfUniqueId, id, region, sortName, sortOrder, status, department)
            }
        }
    }

    const handleAgentIdBlur = () => {
        if (agentId.length > 0 && agentIdKey !== 'Enter') {
            setTimeout(() => {
                handleFilterData(name, agentId, sfUniqueId, id, region, sortName, sortOrder, status, department)
            }, 100)
        }
    }

    const handleSfUniqueIdKeyDown = (event) => {

        if (event.key === 'Enter') {
            setSfUnqueIdEnterKey('Enter')
            if (event.target.value?.length > 0) {
                handleFilterData(name, agentId, event.target.value, id, region, sortName, sortOrder, status, department)
            }
        }
    }

    const handleSfUniqueIdBlur = () => {
        if (sfUniqueId.length > 0 && sfEnterKey !== 'Enter') {
            setTimeout(() => {
                handleFilterData(name, agentId, sfUniqueId, id, region, sortName, sortOrder, status, department)
            }, 100)
        }
    }

    const handleRowClick = (row) => {
        navigate(`/company/${row.id}`)
    }

    function DisplayCondition() {
        return (id || department || sfUniqueId || name || agentId || region || status !== 3)
    }

    // useEffect(() => {
    //     const result = DisplayCondition()
    //     setDisplayFilter(result)
    // }, [])

     const clearFiltersSearch = () => {
        setName("")
        setAgentId("")
        setSfUniqueId("")
        setId(null)
        setStatus(3)
        setRegion("")
        setRegionalOption(null)
        setStatusOption(options[0])
        setDepartment(null)
        setDepartmentOption(null)
        //  setSourceSystem(null)
        handleFilterData("", "", "", null, "", sortName, sortOrder, 3)
    }

    const HoverCard = ({ children, content, placement = 'top', testing }) => {
        const [isVisible, setIsVisible] = useState(false)

        const showTooltip = () => setIsVisible(true)
        const hideTooltip = () => setIsVisible(false)

        return (
            <div
                className="hover-card-wrapper"
                style={{ position: 'relative', display: 'inline-block', pointerEvents: !displaytableData ? "unset" : "none", cursor: !displaytableData ? "pointer" : "not-allowed" }}
                disabled={displaytableData}
                onClick={() => {
                    if (testing) {
                        if (displayFitler && DisplayCondition()) {
                            clearFiltersSearch()
                        } else {
                            setDisplayFilter(!displayFitler)
                        }
                    }
                }}
                onMouseEnter={showTooltip}
                onMouseLeave={hideTooltip}

            >
                {children}
                {isVisible && (
                    <div
                        className={`hover-card hover-card-${placement}`}
                        onMouseEnter={showTooltip}
                        onMouseLeave={hideTooltip}
                        style={{
                            position: 'absolute',
                            zIndex: 1000,
                            // backgroundColor: '#fff',
                            // border: '1px solid #ccc',
                            padding: '8px',
                            borderRadius: '4px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                            top: placement === 'top' ? '-40px' : '40px'
                        }}
                    >
                        {content}
                    </div>
                )}
            </div>
        )
    }

    useEffect(() => {
        setTimeout(() => {
            handleFilterData(name, agentId, sfUniqueId, id, region, sortName, sortOrder, status, department)
        }, 100)
    }, [rowsPerPage, sortOrder])

    const handlePagination = async (page) => {
        setDisplaytableData(true)
        setCurrentPage(page.selected)
        dispatch(getWoLoading(false))
        const obj = {}
        if (true) {
            obj.name = name

            if (agentId?.length) {
                obj.agentId = String(agentId)
            }
            if (sfUniqueId?.length) {
                obj.sfUniqueId = sfUniqueId
            }

            if (department) {
                obj.gpClientDepartmentId = Number(department)
            }

        }
        if (status !== 3) {
            obj.status = status
        }
        //   obj.sourceSystemId = sourceSystem
        obj.pageIndex = (page.selected + 1)
        obj.pageSize = rowsPerPage
        obj.sortName = sortName
        obj.Id = id
        if (region) {
            obj.regionalOfficeId = region
        }
        obj.sortOrder = sortOrder
        let responseData
        if (loggedinUserDetails?.userRoles[0]?.roleId === 1) {
            responseData = await dispatch(getActiveCompanies(obj))
        } else {
            obj.isEmployee = loggedinUserDetails.isEmployee
            obj.userId = loggedinUserDetails.userRoles[0].userId
            responseData = await dispatch(GetUserCompanies(obj))
        }
        if (responseData.payload) {

            loadingData(responseData.payload.data)
        } else {
            setDisplaytableData(false)
        }
    }

    // useEffect(() => {
    //     if (stores.spinner3) {
    //         const debounceHandleSelectedRowsChange = setTimeout(() => {
    //             setStopMultiLoops(true)
    //         }, 100)// Adjust the delay as needed
    //         return () => clearTimeout(debounceHandleSelectedRowsChange)
    //     } else {
    //         setStopMultiLoops(false)
    //     }
    // }, [stores.spinner3])

    const handlePerPage = (e) => {
        const value = parseInt(e.currentTarget.value)
        setRowsPerPage(value)
        setCurrentPage(0)
    }

    const NoOptionsMessage = (props) => {
        return (
            <components.NoOptionsMessage {...props}>
                {addCompanyOption ? (
                    <Fragment>
                        No Options
                    </Fragment>
                ) : (
                    <div>Enter min 3 characters.</div>
                )}
            </components.NoOptionsMessage>
        )
    }

    const CustomPagination = () => (
        <Row className="my-0 mx-0 workorder_pagination_row all_pagination_row">
            <Col sm="12" md="4" lg="3" xl="4" className="d-flex align-items-center p-0 showingEntries ">
                <Label className='mb-0 font-weight-bold showing_panel'>
                    Showing {(((currentPage) * stores.gridSize) + 1)} to {(Math.ceil(stores.recCount / (stores.gridSize)) || 1) !== (currentPage + 1) ? ((((currentPage) * stores.gridSize) + 1) + (stores.gridSize - 1)) : stores.recCount} of {stores.recCount} entries
                </Label>
            </Col>
            <Col sm="12" md="8" lg="9" xl="8"
                className="d-flex align-items-sm-center justify-content-lg-end justify-content-md-end justify-content-start flex-lg-nowrap flex-wrap flex-sm-row flex-column p-0 contentAligment"
            >
                <div className="d-flex align-items-center me-1" style={{ marginTop: "7px" }}>
                    <Label for="rows-per-page font-weight-bold  " className={"form-label1"}>Rows per page: </Label>
                    <Input
                        className="form-control mx-50 "
                        type="select"
                        id="rows-per-page"
                        value={rowsPerPage}
                        onChange={handlePerPage}
                        style={{
                            width: "5rem",
                            padding: "0 0.8rem",
                            backgroundPosition: "calc(100% - 3px) 4px, calc(100% - 20px) 13px, 100% 0"
                        }}
                    >
                        {DefaultSettings?.pagination.map((count, index) => {
                            return (
                                <option value={count.value} key={index.toString()}>
                                    {count.label}
                                </option>
                            )
                        })}
                    </Input>
                </div>
                <ReactPaginate
                    previousLabel={''}
                    nextLabel={''}
                    forcePage={currentPage}
                    onPageChange={page => handlePagination(page)}
                    pageCount={Math.ceil(stores.recCount / (stores.gridSize)) || 1}
                    breakLabel={'...'}
                    pageRangeDisplayed={5}
                    marginPagesDisplayed={5}
                    activeClassName='active'
                    pageClassName='page-item'
                    breakClassName='page-item'
                    nextLinkClassName='page-link'
                    pageLinkClassName='page-link'
                    breakLinkClassName='page-link'
                    previousLinkClassName='page-link'
                    nextClassName='page-item next-item'
                    previousClassName='page-item prev-item'
                    containerClassName={'pagination react-paginate separated-pagination pagination-sm justify-content-end workorder_pagination_view'}
                />
            </Col>
        </Row>
    )

    const handleInputChange = (inputValue, action) => {
        if (action?.action !== "input-blur" && action?.action !== "menu-close") {
            setAgentInput(inputValue)
        }
    }

    useEffect(() => {
        if (agentInput.length > 2) {
            setIsLoading(true)
            const timer = setTimeout(() => {
                const searchOptions = async () => {
                    if (agentInput) {
                        const responseData = await dispatch(GetAgentDetails(agentInput))
                        const companyData = responseData.payload
                        //console.log(companyData, "companyData")
                        if (companyData) {
                            const sfCompanys = []
                            if (companyData.length > 0) {
                                companyData.forEach((item) => {
                                    if (item.customerNumber) {
                                        sfCompanys.push({ value: item.customerNumber, label: `${item.customerName} ${item.customerNumber !== null ? `(${item.customerNumber})` : ''}`, name: item.customerName, agentId: item.customerNumber, classId: item.customerClassId, address1: item.address1, address2: item.address2, city: item.city, customerClassName: item.customerClassName, country: item.country, state: item.state, customerName: item.customerName })
                                    }
                                })
                            } else {
                                setAddCompanyOption(true)
                            }
                            setCompanyData(sfCompanys)
                            setIsLoading(false)
                        }
                    }
                }
                if (agentInput) {
                    setIsLoading(true)
                    setAddCompanyOption(false)
                    searchOptions()
                } else {
                    setIsLoading(false)
                    setCompanyData([])
                }
            }, 500)
            return () => clearTimeout(timer)
        } else {
            setIsLoading(false)
            setCompanyData([])
            setAddCompanyOption(false)
        }
    }, [agentInput])

    const BootstrapCheckbox = forwardRef(({ ...props }, ref) => (
        <div className='form-check' style={{ left: (props.name === 'select-all-rows' && '20px'), position: 'absolute' }}>
            <Input type='checkbox' ref={ref} {...props} />
        </div>
    ))


    const handleSort = (column) => {
        setSortName(column.sortName)
        const sortingorder = sortOrder
        if (sortingorder === '') {
            setSortOrder('asc')
        } else if (sortingorder === 'asc') {
            setSortOrder('desc')
        } else if (sortingorder === 'desc') {
            setSortOrder('asc')
        }
    }

    const handleReset = () => {
        if (true) {
            setAgentObj(null)
        }
    }

    const toggleSidebar = () => {
        handleReset()
        setShow(!show)
    }

    async function ImportCompanyApi() {
        setSidebarSpinnerStatus(true)
        const obj = {}
        obj.agentId = String(agentObj.agentId)
        obj.agentName = agentObj.customerName
        obj.gPClientDepartmentId = agentObj.classId
        obj.createdDate = new Date()
        const response = await dispatch(ImportCompany(obj)).finally(() => {
            setSidebarSpinnerStatus(false)
        })
        if (response.payload) {
            toast(t => (<ToastMessage t={t} message={"Company Imported Successfully"} status={"success"} />))
            setAgentObj(null)
            setShow(false)
            handleFilterData("", "", "", null, "", "Id", "desc", 3, null)
        }

    }

    return (
        <>
            <Sidebar
                size="sm"
                open={show}
                title={"Company Import"}
                headerClassName="mb-1"
                contentClassName="pt-0"
                toggleSidebar={toggleSidebar}
            >
                {(show) ? (
                    <div>
                        <ModalBody style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                            {<div>
                                <div className='select_create mt-1' >
                                    <Select
                                        // ref={selectRefs}
                                        isClearable
                                        onChange={(val) => {
                                            if (val?.agentId) {
                                                // const bufferList = [...listAgentIds]
                                                // bufferList.push(val)
                                                // const addAgentIfNotExist = (val) => {
                                                //     const existingAgent = agents.find(agent => agent.agentId === val.agentId)
                                                //     const existingData = stores?.userDetailswithId?.userCompanies?.find((item) => item.agentId === Number(val.agentId))
                                                //     console.log(existingAgent, existingData, "exiting", stores?.userDetailswithId?.userCompanies, val)
                                                //     if (!existingAgent && !existingData) {
                                                //         if (bufferList.length) {
                                                //             setAgentError('')
                                                //         }
                                                //         agents.push(val)
                                                //         setListAgentId(agents)
                                                //     } else {
                                                //         setAgentError(`Agent with agentId ${val.agentId} already exists.`)
                                                //     }
                                                // }
                                                // addAgentIfNotExist( val)
                                                setAgentObj(val)
                                            }
                                            if (val === null) {
                                                setAgentObj(val)
                                            }
                                        }}
                                        inputValue={agentInput}
                                        classNamePrefix="select"
                                        options={companyData}
                                        value={agentObj?.label ? agentObj : null}
                                        components={{ NoOptionsMessage, ValueContainer: CustomValueContainer }}
                                        styles={selectStyles}
                                        className={classnames('react-select')}
                                        onInputChange={handleInputChange}
                                        isLoading={isLoading}
                                        loadingMessage={() => 'Loading...'}
                                        placeholder={`Select Agent Id or Name<span class='text-danger'>*</span>`}
                                        id='showAgentTooltip'
                                    />
                                </div>
                                {/* {agentError.length ? <div style={{ marginTop: "10px", color: "red", fontSize: "14px" }}>{agentError}</div> : ""} */}
                                {agentObj && <Col style={{ margin: "0px", padding: "0px" }}>
                                    <h6 className="pt-1 " style={{ margin: "auto", color: "#000", fontWeight: 500 }}>Company Details</h6>
                                    <div className="pt-2 " style={{ margin: "auto" }}>
                                        <div className='frist_Company_lableview_p1_warpper d-flex'>
                                            <div className='company_ct_lable_warpper1_invoice' >
                                                <h6 className='p-0 Company_lableview_p1'>Agent Name</h6>
                                            </div>
                                            <div className='company_ct_lable_warpper_invoice' >
                                                <h6 className='p-0 Company_lableview_p2'>{agentObj?.customerName}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pt-1 " style={{ margin: "auto" }}>
                                        <div className='frist_Company_lableview_p1_warpper d-flex'>
                                            <div className='company_ct_lable_warpper1_invoice' >
                                                <h6 className='p-0 Company_lableview_p1'>Agent ID</h6>
                                            </div>
                                            <div className='company_ct_lable_warpper_invoice' >
                                                <h6 className='p-0 Company_lableview_p2'>{agentObj?.agentId}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pt-1 " style={{ margin: "auto" }}>
                                        <div className='frist_Company_lableview_p1_warpper d-flex'>
                                            <div className='company_ct_lable_warpper1_invoice' >
                                                <h6 className='p-0 Company_lableview_p1'>Source System</h6>
                                            </div>
                                            <div className='company_ct_lable_warpper_invoice' >
                                                <h6 className='p-0 Company_lableview_p2'>{agentObj?.classId}</h6>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pt-1" style={{ margin: "auto" }}>
                                        <div className='frist_Company_lableview_p1_warpper d-flex'>
                                            <div className='company_ct_lable_warpper1_invoice'>
                                                <h6 className='p-0 Company_lableview_p1'>Address 1</h6>
                                            </div>
                                            <div className='company_ct_lable_warpper_invoice'>
                                                <h6 className='p-0 Company_lableview_p2'>{agentObj?.address1 || '-'}</h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-1" style={{ margin: "auto" }}>
                                        <div className='frist_Company_lableview_p1_warpper d-flex'>
                                            <div className='company_ct_lable_warpper1_invoice'>
                                                <h6 className='p-0 Company_lableview_p1'>Address 2</h6>
                                            </div>
                                            <div className='company_ct_lable_warpper_invoice'>
                                                <h6 className='p-0 Company_lableview_p2'>{agentObj?.address2 || '-'}</h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-1" style={{ margin: "auto" }}>
                                        <div className='frist_Company_lableview_p1_warpper d-flex'>
                                            <div className='company_ct_lable_warpper1_invoice'>
                                                <h6 className='p-0 Company_lableview_p1'>City</h6>
                                            </div>
                                            <div className='company_ct_lable_warpper_invoice'>
                                                <h6 className='p-0 Company_lableview_p2'>{agentObj?.city || '-'}</h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-1" style={{ margin: "auto" }}>
                                        <div className='frist_Company_lableview_p1_warpper d-flex'>
                                            <div className='company_ct_lable_warpper1_invoice'>
                                                <h6 className='p-0 Company_lableview_p1'>State</h6>
                                            </div>
                                            <div className='company_ct_lable_warpper_invoice'>
                                                <h6 className='p-0 Company_lableview_p2'>{agentObj?.state || '-'}</h6>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-1" style={{ margin: "auto" }}>
                                        <div className='frist_Company_lableview_p1_warpper d-flex'>
                                            <div className='company_ct_lable_warpper1_invoice'>
                                                <h6 className='p-0 Company_lableview_p1'>Country</h6>
                                            </div>
                                            <div className='company_ct_lable_warpper_invoice'>
                                                <h6 className='p-0 Company_lableview_p2'>{agentObj?.country || '-'}</h6>
                                            </div>
                                        </div>
                                    </div>

                                </Col>}
                            </div>}

                        </ModalBody>
                        <ModalFooter className='p-0 d-block' style={{ border: 0, marginTop: '30px' }}>
                            <Row>
                                <Col sm='12' md='12' lg='12' xl='12' className='p-0 mt-1'>
                                    <div className='model_popup_panel model_popup_submit_btn model_popup_footer_fixed' style={{ justifyContent: 'center', padding: "12px 0px", display: "flex", background: "unset" }}>
                                        {sidebarSpinnerStatus ? (
                                            <Button.Ripple color='primary' disabled={sidebarSpinnerStatus} style={{ paddding: "0px 0px" }}>
                                                <Spinner size='sm' />
                                                <span className='mx-50'>Loading...</span>
                                            </Button.Ripple>
                                        ) : (
                                            <Fragment>
                                                <Button className='me-1 reset_button_view' outline color='secondary' style={{ paddding: "0px 0px" }} onClick={() => handleReset()}>
                                                    <RefreshCcw size={14} className='align-middle me-sm-25 me-0' />
                                                    <span className='align-middle d-sm-inline-block mx-50'>Reset</span>
                                                </Button>
                                                <Button className='create_submit_btn' style={{ paddding: "0px 0px" }} disabled={!agentObj} onClick={() => {
                                                    ImportCompanyApi()
                                                }}>
                                                    {/* <Check size={18} className='align-middle me-sm-25 me-0'></Check> */}
                                                    {(true) ? <Plus size={18} /> : ""}
                                                    <span className='align-middle d-sm-inline-block mx-50'>{"Add Company"}</span>
                                                </Button>
                                            </Fragment>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </ModalFooter>
                    </div>
                ) : (
                    <ComponentSpinner />
                )}
            </Sidebar >

            <Row className="billing-sec" style={{ margin: "0px", paddingTop: '20px' }}>
                <Row style={{ width: "100%" }}>
                    {displayFitler ? <Col md='6' lg='3' xl='3' className='filter_bill1'>Filter By :</Col> : ""}
                    <Col md={displayFitler ? '6' : "12"} lg={displayFitler ? '9' : "12"} xl={displayFitler ? '9' : "12"} className="d-flex align-items-center justify-content-end" style={{ color: '#707070' }}>
                        {/* Filter controls with hover cards */}
                        <HoverCard
                            content={displayFitler && DisplayCondition() ? "Clear All Filters" : (displayFitler ? "Hide Filters" : "Show Filters")}
                            placement="top"
                            testing="checking"
                        >
                            <span className="action-icon mx-1" >
                                {displayFitler && DisplayCondition() ? (
                                    <>
                                        <div style={{ position: 'relative', display: 'inline-block', color: "#707070" }}>
                                            <Filter size={24} />
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    top: "-4px",
                                                    right: "24%",
                                                    fontSize: "24px",
                                                    fontWeight: "500"
                                                }}
                                            >/</span>
                                        </div >
                                    </>
                                ) : (
                                    <Filter size={24} className="svg-icon" />
                                )}
                            </span>
                        </HoverCard>
                    </Col>

                </Row>
                {displayFitler &&
                    <Row style={{ marginTop: '10px' }}>
                        <Col md="4" lg="3" xl="3" sm="12" className='mb-1 filter-padding d-none'>
                            <div className='input-wrapper'>
                                <Input id='invoiceNum'
                                    type="text"
                                    placeholder=''
                                    value={id}
                                    onBlur={handleIdBlur}
                                    onChange={(e) => {
                                        if (!isNaN(e.target.value)) {
                                            setId(Number(e.target.value))
                                            setIdEnterKey('')
                                        }
                                        if (!e.target.value) {
                                            handleFilterData(name, agentId, sfUniqueId, null, sortName, sortOrder, status, department)
                                        }
                                    }}
                                    onKeyDown={handleIdKeyDown}
                                    autoComplete="off"
                                />
                                <Label className='form-label input_label' for='invoiceNum'>Company ID</Label>
                                {id &&
                                    <div onClick={() => {
                                        setId(null)
                                        setIdEnterKey('')
                                        handleFilterData(name, agentId, sfUniqueId, null, sortName, sortOrder, status, department)
                                    }} className='clear-icon'>
                                        <X size={16} strokeWidth={3} />
                                    </div>
                                }
                            </div>

                        </Col>
                        <Col md="4" lg="3" xl="3" sm="12" className='mb-1 filter-padding'>
                            <div className='input-wrapper'>
                                <Input id='invoiceNum'
                                    type="text"
                                    placeholder=''
                                    value={name}
                                    onBlur={handleNameBlur}
                                    onChange={(e) => {
                                        setName(e.target.value)
                                        setNameEnterKey('')
                                        if (!e.target.value) {
                                            handleFilterData("", agentId, sfUniqueId, id, region, sortName, sortOrder, status, department)
                                        }
                                    }}
                                    onKeyDown={handleNameKeyDown}
                                    autoComplete="off"
                                />
                                <Label className='form-label input_label' for='invoiceNum'>Company Name</Label>
                                {name &&
                                    <div onClick={() => {
                                        setName('')
                                        setNameEnterKey('')
                                        handleFilterData('', agentId, sfUniqueId, id, region, sortName, sortOrder, status, department)
                                    }} className='clear-icon'>
                                        <X size={16} strokeWidth={3} />
                                    </div>
                                }
                            </div>

                        </Col>
                        <Col md="4" lg="3" xl="3" sm="12" className='mb-1 filter-padding'>
                            <div className='input-wrapper'>
                                <Input id='invoiceNum'
                                    type="text"
                                    placeholder=''
                                    value={agentId}
                                    onBlur={handleAgentIdBlur}
                                    onChange={(e) => {
                                        if ((e.target.value)) {
                                            setAgentId(e.target.value)
                                        }
                                        if (!e.target.value) {
                                            handleFilterData(name, "", sfUniqueId, id, region, sortName, sortOrder, status, department)
                                        }
                                        setAgentIdEnterKey('')
                                    }}
                                    onKeyDown={handleAgentIdKeyDown}
                                    autoComplete="off"
                                />
                                <Label className='form-label input_label' for='invoiceNum'>Agent ID</Label>
                                {agentId &&
                                    <div onClick={() => {
                                        setAgentId('')
                                        setAgentIdEnterKey('')
                                        handleFilterData(name, "", sfUniqueId, id, region, sortName, sortOrder, status, department)
                                    }} className='clear-icon'>
                                        <X size={16} strokeWidth={3} />
                                    </div>
                                }
                            </div>
                        </Col>
                        <Col md="4" lg="3" xl="3" sm="12" className='mb-1 filter-padding'>
                            <div className='input-wrapper'>
                                <Input id='invoiceNum'
                                    type="text"
                                    placeholder=''
                                    value={sfUniqueId}
                                    onBlur={handleSfUniqueIdBlur}
                                    onChange={(e) => {
                                        if (!isNaN(e.target.value)) {
                                            setSfUniqueId(e.target.value)
                                        }
                                        setSfUnqueIdEnterKey('')
                                        if (!e.target.value) {
                                            handleFilterData(name, agentId, "", id, region, sortName, sortOrder, status, department)
                                        }
                                    }}
                                    onKeyDown={handleSfUniqueIdKeyDown}
                                    autoComplete="off"
                                />
                                <Label className='form-label input_label' for='invoiceNum'>SF Unique ID</Label>
                                {sfUniqueId &&
                                    <div onClick={() => {
                                        setSfUniqueId('')
                                        setSfUnqueIdEnterKey('')
                                        handleFilterData(name, agentId, "", id, region, sortName, sortOrder, status, department)
                                    }} className='clear-icon'>
                                        <X size={16} strokeWidth={3} />
                                    </div>
                                }
                            </div>

                        </Col>
                        <Col sm='12' md='4' lg='3' xl='3' className="mb-1 filter-padding ">
                            {<Select
                                classNamePrefix="select"
                                options={regionalOffices}
                                value={regionalOption}
                                onChange={(val) => {
                                    setRegionalOption(val)
                                    if (val) {
                                        setRegion(val?.id)
                                        handleFilterData(name, agentId, sfUniqueId, id, val?.id, sortName, sortOrder, status, department)
                                    } else {
                                        setRegion("")
                                        handleFilterData(name, agentId, sfUniqueId, id, "", sortName, sortOrder, status, department)
                                    }
                                }}
                                isClearable
                                className={classnames('react-select')}
                                placeholder={`Regional Office`}
                                styles={selectStyles}
                                components={{ ValueContainer: CustomValueContainer }}
                            />}
                        </Col>
                        <Col sm='12' md='4' lg='3' xl='3' className="mb-1 filter-padding select_Field">
                            {<Select
                                classNamePrefix="select"
                                options={DepartmentMapping()}
                                value={departmentOption}
                                onChange={(val) => {
                                    setDepartmentOption(val)
                                    if (val) {
                                        setDepartment(val?.id)
                                        handleFilterData(name, agentId, sfUniqueId, id, region, sortName, sortOrder, status, val?.id)
                                    } else {
                                        setDepartment("")
                                        handleFilterData(name, agentId, sfUniqueId, id, region, sortName, sortOrder, status, "")
                                    }
                                }}
                                isClearable
                                className={classnames('react-select')}
                                placeholder={`GP Client Department`}
                                styles={selectStyles}
                                components={{ ValueContainer: CustomValueContainer }}
                            />}
                        </Col>
                        <Col sm='12' md='4' lg='3' xl='3' className="mb-1 filter-padding">
                            <div>
                                <Select
                                    classNamePrefix="select"
                                    options={options}
                                    value={statusOption}
                                    onChange={(val) => {
                                        setStatusOption(val)
                                        if (val?.id) {
                                            setStatus(val?.id)
                                        }
                                        handleFilterData(name, agentId, sfUniqueId, id, region, sortName, sortOrder, val?.id, department)
                                    }}
                                    className={classnames('react-select')}
                                    placeholder={`Select Status`}
                                    styles={selectStyles}
                                    components={{ ValueContainer: CustomValueContainer }}
                                />
                            </div>
                        </Col>

                        {/* <Col sm='12' md='4' lg='3' xl='3' className="mb-1 filter-padding">
                            {<Select
                                classNamePrefix="select"
                                options={mappedSourceSystems()}
                                value={sourceSystemOption}
                                onChange={(val) => {
                                    setSourceSystemOption(val)
                                    if (val) {
                                        console.log(val)
                                        setSourceSystem(val?.value)
                                        handleFilterData(name, agentId, sfUniqueId, id, region, sortName, sortOrder, status, department, val?.value)
                                    } else {
                                        setSourceSystem(null)
                                        handleFilterData(name, agentId, sfUniqueId, id, region, sortName, sortOrder, status, department, null)
                                    }
                                }}
                                isClearable
                                className={classnames('react-select')}
                                placeholder={`Source Systems`}
                                styles={selectStyles}
                                components={{ ValueContainer: CustomValueContainer }}
                            />}
                        </Col> */}

                        <Col md="4" lg="1" xl="1" sm="12" className='mb-1 filter-padding billing_download_section d-none' style={{ marginTop: "5px" }}>
                            {(sfUniqueId || name || agentId || region) &&
                                <Button color='primary' className='btn-prev mr-2' onClick={() => clearFiltersSearch()} style={{ width: '116px' }} >
                                    <RefreshCcw size={14} className='' />
                                    <span className='align-middle d-sm-inline-block mx-50'>Reset</span>
                                </Button>
                            }
                        </Col>

                        <Col md="4" lg="12" xl="12" sm="12" className='mb-1 filter-padding billing_download_section d-none' style={{ marginTop: "5px" }}>
                            {
                                <Button color='primary' className='btn-prev mr-2'
                                    onClick={() => setShow(true)}
                                //  style={{ width: '116px' }}
                                >
                                    <Plus size={14} className='' />
                                    <span className='align-middle d-sm-inline-block mx-50'>Import Company</span>
                                </Button>
                            }
                        </Col>
                    </Row>
                }
                <div 
                // className="d-flex justify-content-between" 
                style={{ marginTop : displayFitler ? '0px' : '-32px' }}
                >
                    <div className='mb-1 filter-padding d-none' style={{ marginTop: "10px" }}>
                        <Input
                            style={{ marginTop: "6px" }}
                            type="checkbox"
                            checked={!status}
                            //  onChange={handleCheckboxChange}
                            className="d-none"
                        />
                        <span className='mx-1 d-none' style={{ fontSize: "14px", color: "#000" }}>All Companies</span>
                        {(sfUniqueId || name || agentId || status !== 3 || region) &&
                            <Button color='primary' className='btn-prev' onClick={() => clearFiltersSearch()} style={{ width: '116px' }} >
                                <RefreshCcw size={13} className='' />
                                <span className='align-middle d-sm-inline-block' style={{ margin: "0px 3px" }}>Reset</span>
                            </Button>
                        }
                    </div>
                    {showImportCompBtn() && (
                        < div className='mb-1 filter-padding' style={{ marginTop: (sfUniqueId || name || agentId || !status) ? "10px" : "" }}>
                            <div style={{ display: "flex", justifyContent: "start" }}>
                                <Button.Ripple color='primary' onClick={() => setShow(!show)} style={{ maxWidth: "250px", margin: '0px 4px', textAlign: "left", maxHeight: "40px" }}>
                                    <Plus size={14} className='' style={{ marginTop: '-7px' }} />
                                    <span className='align-middles mx-50'>Import Company</span>
                                </Button.Ripple>
                            </div>
                        </div>
                    )}
                </div>
                <Col lg='12' md='12'>
                    {(stores.spinner3 && !displaytableData) ? (
                        <TabContent className="custom-tab-content">
                            <div className={woData.length > 0 ? 'react-dataTable react_main_warpper_table' : 'react-dataTable react_main_warpper_table rdt_Table_Height h-50'}>
                                <TabPane>
                                    <DataTable
                                        noHeader
                                        pagination
                                        columns={ActiveCompanies(handleRowClick)}
                                        selectableRowsComponent={BootstrapCheckbox}
                                        paginationPerPage={stores.gridSize}
                                        className='react-dataTable  custom-data-table react_main_sub_warpper bill-data-table-container user_listTabel my-table-with-custom-header'
                                        sortIcon={sortOrder === 'asc' ? <ChevronUp size={10} /> : <ChevronDown size={10} />}
                                        paginationDefaultPage={currentPage + 1}
                                        paginationComponent={CustomPagination}
                                        data={woData.length ? woData : []}
                                        noDataComponent={woData.length === 0 && 'There are no records to display'}
                                        fixedColumns
                                        onSort={handleSort}
                                        onRowClicked={handleRowClick}
                                        highlightOnHover
                                        customStyles={customStyles}
                                        // conditionalRowStyles={[
                                        //     {
                                        //         when: (row, index) => index % 2 === 0,
                                        //         style: {
                                        //             backgroundColor: '#ffffff'
                                        //         }
                                        //     },
                                        //     {
                                        //         when: (row, index) => index % 2 !== 0,
                                        //         style: {
                                        //             backgroundColor: '#dedede'
                                        //         }
                                        //     }
                                        // ]}
                                        pointerOnHover
                                    />
                                </TabPane>
                            </div>
                        </TabContent>
                    ) : (
                        <ComponentSpinner />
                    )}
                </Col>
            </Row >

        </>

    )
}

export default CompaniesList
